export const currentVersion = {
  buildTime: '28/10/2026 17:38'
};